import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useSession } from 'store/session';
import { useCallback } from 'react';
import { AxiosError } from 'axios';
import { translations } from 'translations';
import { useTranslation } from 'react-i18next';
import { useToast } from '@chakra-ui/react';
import { ERROR_TOAST_DEFAULTS } from '@helpers';
import { useRouter } from 'hooks/useRouter';

export const useFetch = ({ folder, document, token, team }) => {
  const client = useClient({
    token: resolveTokenV3(token),
    url: process.env.REACT_APP_API_V3,
  });

  const { team: defaultTeam } = useSession();

  const { t } = useTranslation();

  const toast = useToast();

  const router = useRouter();

  const teamUUID = defaultTeam?.uuid as string;

  const fn = async () => {
    const response = await client.getDocumentV3(
      team ?? teamUUID,
      folder,
      document,
    );
    return response;
  };

  const onError = useCallback(
    (error: AxiosError) => {
      if (error?.response?.status === 403) {
        const msg = t(
          translations.DOCUMENT_PAGES.SIGN_DOCUMENT_STATUS_CODE_403,
        );
        toast({ ...ERROR_TOAST_DEFAULTS, title: msg });
        router.push('/');
      }
    },
    [router, t, toast],
  );

  const query = useQuery(['get-document', document], fn, {
    enabled: Boolean(folder && document),
    onError,
  });

  return { ...query };
};
